import { createFileRoute } from '@tanstack/react-router';

import ComingSoonCover from '@/components/ComingSoonCover';

export const Route = createFileRoute(
  '/_staff/supplier/$supplierId/_layout/settings',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <ComingSoonCover disableBlurBackdrop={true} />;
}
